import Vue from 'vue'
import api from '../../plugins/api'

export default {
    namespaced: true,
    state: {
        current: {
            nom: "Doe",
            prenom: "John",
        },
        user: {},
        userHistory: {},
        users: {},
        notifications: {
            count: 0,
            list: {}
        }
    },
    actions: {
        setCurrentUser: ({ commit }) => {
            let user = JSON.parse(localStorage.getItem('user'))
            commit("SET_CURRENT_USER", user)
        },
        getCurrentUser: ({ commit }) => {
            let user = JSON.parse(localStorage.getItem('user'))
            return Vue.http.get('user/' + user.id)
                .then(response => commit("SET_CURRENT_USER", response.body))
                .catch(error => { api.error(commit, error) })
        },
        getUser: ({ commit }, user_id) => {
            return Vue.http.get('user/' + user_id)
                .then(response => commit("SET_USER", response.body))
                .catch(error => { api.error(commit, error) })
        },
        getMyProfile: ({ commit }) => {
            return Vue.http.get('me')
                .then(response => commit("SET_USER", response.body))
                .catch(error => { api.error(commit, error) })
        },
        getUserHistory: ({ commit }) => {
            let user = JSON.parse(localStorage.getItem('user'))
            return Vue.http.get('user/' + user.id + '/history')
                .then(response => commit("SET_USER_HISTORY", response.body))
                .catch(error => { api.error(commit, error) })
        },
        setTheme: ({ commit }, data) => {
            let user = JSON.parse(localStorage.getItem('user'))
            return Vue.http.put('user/' + user.id + '/theme', { dark_mode: data.dark_mode, third_color: data.third_color }, { emulateJSON: true })
                .then(response => {})
                .catch(error => { api.error(commit, error) })
        },
        getUserNotifications: ({ commit }) => {
            let user = JSON.parse(localStorage.getItem('user'))
            return Vue.http.get('user/' + user.id + '/notification')
                .then(response => commit("SET_USER_NOTIFICATION", response.body))
                .catch(error => { api.error(commit, error) })
        },
        countUserNotification: ({ commit }) => {
            if(!localStorage.getItem('user')) return false
            let user = JSON.parse(localStorage.getItem('user'))
            return Vue.http.get('user/' + user.id + '/notification/count')
                .then(response => commit("SET_COUNT_USER_NOTIFICATION", response.body))
                .catch(error => { return false })
        }
    },
    mutations:{
        SET_CURRENT_USER: (state, data) => {
            return state.current = data
        },
        SET_USER: (state, data) => {
            return state.user = data
        },
        SET_USER_HISTORY: (state, data) => {
            return state.userHistory = data
        },
        SET_USER_NOTIFICATION: (state, data) => {
            return state.notifications.list = data
        },
        SET_COUNT_USER_NOTIFICATION: (state, data) => {
            return state.notifications.count = data.count
        }
    },
    getters: {
        current: (state) => state.current,
        user: (state) => state.user,
        userHistory: (state) => state.userHistory,
        userNotification: (state) => state.notifications
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js